module.exports = __webpack_public_path__ + "img/coin2.380a72ed.svg";